import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getEventFormStepFields, getEventFormSteps, getEventFormStepsAndFields, updateDashboardResponseGrid } from './eventDashboardThunk';
const initialState = {
    status: APIStatus.IDLE,
    formSteps: null,
    formQuantitableFields: null,
    formStepsAndFields: null,
    isFormUpdated: false
};
export const eventDashboardSlice = createSlice({
    name: 'eventDashboard',
    initialState,
    reducers: {
        setIsFormUpdated: (state) => {
            state.isFormUpdated = !state.isFormUpdated;
        },
        clearStepsAndFields: (state) => {
            state.formStepsAndFields = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getEventFormSteps.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        });
        builder.addCase(getEventFormSteps.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formSteps = action.payload;
        });
        builder.addCase(getEventFormSteps.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder.addCase(getEventFormStepFields.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        });
        builder.addCase(getEventFormStepFields.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formQuantitableFields = action.payload;
        });
        builder.addCase(getEventFormStepFields.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //=======================================================================
        builder.addCase(getEventFormStepsAndFields.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        });
        builder.addCase(getEventFormStepsAndFields.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formStepsAndFields = action.payload;
        });
        builder.addCase(getEventFormStepsAndFields.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //=======================================================================
        builder.addCase(updateDashboardResponseGrid.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        });
        builder.addCase(updateDashboardResponseGrid.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formStepsAndFields = action.payload;
        });
        builder.addCase(updateDashboardResponseGrid.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { setIsFormUpdated, clearStepsAndFields } = eventDashboardSlice.actions;
export default eventDashboardSlice.reducer;
